<template>
    <app-container class="search-page">
        <search-header :total="total"/>
        <!-- 骨架屏 -->
        <pre-view-skeleton v-if="!articleList.length"/>
        <!-- 博客列表 -->
        <template v-else v-for="article in articleList">
            <blogpost-preview-item :key="article.id" :data="article"/>
        </template>
        <!-- load more -->
        <div class="search-page__loading"
             v-observe-visibility="{
              callback: handleLoadList,
              throttle: 250
         }">
            <app-button class="search-page__load-more"
                        v-if="showLoadMore"
                        @click="handleLoadList(true)">
                加载更多
                <app-icon value="icon-enter"/>
            </app-button>
            <app-loading v-if="loading"/>
        </div>

    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import BlogpostPreviewItem from '@components/BlogpostPreviewItem'
    import AppLoading from '@components/AppLoading'
    import SearchHeader from './components/Header'
    import getArticleListService from '@service/getArticleListService'
    import {DEFAULT_LIMIT} from '@config'
    import AppButton from '@components/AppButton'
    import AppIcon from '@components/AppIcon'

    import PreViewSkeleton from '@assets/svg/inline.preview-skeleton.svg'

    export default {
        name: "Search",
        data() {
            return {
                isLoaded:false,
                loading: false,
                error: false,
                index: 0,
                limit: DEFAULT_LIMIT,
                total: 0,
                articleList: []
            }
        },
        computed: {
            showLoadMore() {
                const {loading, error, limit, index, total} = this
                if (index === 0) {
                    return (total === 0 && !loading && error)
                } else {
                    const current = (index + 1) * limit
                    // 当前数量小于分页数量，并且错误 并且不在加载中
                    return ((current < total) && !loading && error)
                }
                // !loading&&error
            },
            query() {
                const params = this.$route.query
                return params.query || ''
            }
        },
        watch: {
            query: {
                handler(query) {
                    if (query) {
                        this.articleList = []
                        this.getArticleList()
                    }
                },
                immediate: true
            }
        },
        methods: {
            async getArticleList(index = 0) {
                try {
                    this.loading = true
                    const {limit, articleList, query} = this
                    const {data, limit: dataLimit, total, index: dataIndex} = await getArticleListService({
                        title: query,
                        index,
                        limit
                    })
                    this.total = total
                    this.limit = dataLimit
                    this.index = dataIndex
                    this.articleList = articleList.concat(data)
                    this.error = false
                } catch (e) {
                    this.error = true
                    console.log(e)
                } finally {
                    this.loading = false
                }
            },
            handleLoadList(isVisible, flag) {
                const {loading} = this
                if (isVisible && !loading) {
                    const {index, limit, total} = this
                    if ((((index + 1) * limit) < total) || flag === true) {
                        this.getArticleList(index + 1)
                    }

                }
            }
        },
        components: {
            AppIcon,
            AppButton,
            SearchHeader,
            AppContainer,
            BlogpostPreviewItem,
            AppLoading,
            PreViewSkeleton
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .search-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        max-width: 800px;

        &__loading {
            margin-top: $paddingMD;
            text-align: center;
        }

        &__load-more {
            font-size: $fontSizeCommon;
        }
    }
</style>